export default {"src":"/_next/static/media/Add-Compound.7cc25fb4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};